// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1_7AI","consentsList":"PatientConsents_consentsList__T3x4n","consentsListEmpty":"PatientConsents_consentsListEmpty__25p1D"};